import { ThemeConfig } from "./theme-config";

export const DEFAULT_THEME: ThemeConfig = {
    themeId: "default-theme-id",
    mainColors: {
        primaryColor: "#5a2866",
        accentColor: "#ffffff",
        warnColor: "#c791d4"
    },
    images: {
        primaryLogoUrl: "assets/images/poweredby-logo-p.svg",
        secondaryLogoUrl: "assets/images/poweredby-logo.svg",
        poweredByLogoUrl: null,
        bannerUrl: "assets/images/logo-white-horizontal.png",
        favIconUrl: "assets/icons/app-icon.png"
    }
};
